import { render } from "./indexfivebanner.vue?vue&type=template&id=57f41b0a"
import script from "./indexfivebanner.vue?vue&type=script&lang=js"
export * from "./indexfivebanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__